import { render, staticRenderFns } from "./InvitesLayouts.vue?vue&type=template&id=112a63a6&scoped=true&"
import script from "./InvitesLayouts.vue?vue&type=script&lang=js&"
export * from "./InvitesLayouts.vue?vue&type=script&lang=js&"
import style0 from "./InvitesLayouts.vue?vue&type=style&index=0&id=112a63a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112a63a6",
  null
  
)

export default component.exports